import { z } from 'zod'

export const VServerSmtpRequestStatus = z.enum(['none', 'pending', 'approved', 'denied'])
export type VServerSmtpRequestStatus = z.infer<typeof VServerSmtpRequestStatus>

/** Outbound port 25 state of the signed-in account, shared by all its VServers. */
export const VServerSmtpStatus = z.object({
  blocked: z.boolean(),
  opens_at: z.string().nullish(),
  grandfathered: z.boolean(),
  forced: z.boolean(),
  request_status: VServerSmtpRequestStatus,
  requested_at: z.string().nullish(),
  decided_at: z.string().nullish(),
  decision_note: z.string().nullish(),
  request_cooldown_until: z.string().nullish(),
  can_request: z.boolean()
})
export type VServerSmtpStatus = z.infer<typeof VServerSmtpStatus>

/** Admin queue row. Unlike the customer view it carries the operator's forced_reason. */
export const VServerSmtpRequestRow = z.object({
  account_id: z.number(),
  email: z.string(),
  name: z.string(),
  created: z.string().nullish(),
  age_days: z.number(),
  vserver_count: z.number(),
  email_verified: z.boolean(),
  has_payment_method: z.boolean(),
  request_status: VServerSmtpRequestStatus,
  requested_at: z.string().nullish(),
  reason: z.string().nullish(),
  decided_at: z.string().nullish(),
  decision_note: z.string().nullish(),
  opens_at: z.string().nullish(),
  forced_reason: z.string().nullish(),
  blocked: z.boolean(),
  grandfathered: z.boolean(),
  forced: z.boolean()
})
export type VServerSmtpRequestRow = z.infer<typeof VServerSmtpRequestRow>

/**
 * What every admin decision returns. `tag_sync` is the push of the VM tags that
 * open or close port 25 on the host: "deferred" and "failed" mean the decision
 * is saved but the hosts follow only with the next sync run.
 */
export const VServerSmtpDecisionResult = z.object({
  account: VServerSmtpRequestRow,
  tag_sync: z.enum(['ok', 'deferred', 'failed'])
})
export type VServerSmtpDecisionResult = z.infer<typeof VServerSmtpDecisionResult>
